"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.commonDataMocks = void 0;

var _msw = require("msw");

var getCountriesMock = _msw.rest.get('/api/v1/countries', function (req, res, ctx) {
  return res(ctx.json({
    data: [{
      id: 2,
      name: 'Canada',
      code: 'CA',
      image: 'https://qa.alycedev.com/images/ca-flag.png',
      currency: {
        id: 2,
        name: 'Canada dollar',
        sign: 'CAD',
        code: 'CAD',
        image: 'https://qa.alycedev.com/images/ca-flag.png'
      },
      isInternational: false
    }, {
      id: 3,
      name: 'United Kingdom',
      code: 'GB',
      image: 'https://qa.alycedev.com/images/uk-flag.png',
      currency: {
        id: 3,
        name: 'Euro',
        sign: '\u20ac',
        code: 'EUR',
        image: 'https://qa.alycedev.com/images/eu-flag.png'
      },
      isInternational: true
    }, {
      id: 1,
      name: 'United States',
      code: 'US',
      image: 'https://qa.alycedev.com/images/us-flag.png',
      currency: {
        id: 1,
        name: 'US dollar',
        sign: '$',
        code: 'USD',
        image: 'https://qa.alycedev.com/images/us-flag.png'
      },
      isInternational: false
    }]
  }));
});

var getCommonDataMock = _msw.rest.get('/enterprise/dashboard/common', function (req, res, ctx) {
  return res(ctx.json({
    success: true,
    usa_states: [{
      name: 'Alabama',
      code: 'AL'
    }, {
      name: 'Alaska',
      code: 'AK'
    }, {
      name: 'Arizona',
      code: 'AZ'
    }, {
      name: 'Arkansas',
      code: 'AR'
    }, {
      name: 'California',
      code: 'CA'
    }, {
      name: 'Colorado',
      code: 'CO'
    }, {
      name: 'Connecticut',
      code: 'CT'
    }, {
      name: 'Delaware',
      code: 'DE'
    }, {
      name: 'District of Columbia',
      code: 'DC'
    }, {
      name: 'Florida',
      code: 'FL'
    }, {
      name: 'Georgia',
      code: 'GA'
    }, {
      name: 'Hawaii',
      code: 'HI'
    }, {
      name: 'Idaho',
      code: 'ID'
    }, {
      name: 'Illinois',
      code: 'IL'
    }, {
      name: 'Indiana',
      code: 'IN'
    }, {
      name: 'Iowa',
      code: 'IA'
    }, {
      name: 'Kansas',
      code: 'KS'
    }, {
      name: 'Kentucky',
      code: 'KY'
    }, {
      name: 'Louisiana',
      code: 'LA'
    }, {
      name: 'Maine',
      code: 'ME'
    }, {
      name: 'Maryland',
      code: 'MD'
    }, {
      name: 'Massachusetts',
      code: 'MA'
    }, {
      name: 'Michigan',
      code: 'MI'
    }, {
      name: 'Minnesota',
      code: 'MN'
    }, {
      name: 'Mississippi',
      code: 'MS'
    }, {
      name: 'Missouri',
      code: 'MO'
    }, {
      name: 'Montana',
      code: 'MT'
    }, {
      name: 'Nebraska',
      code: 'NE'
    }, {
      name: 'Nevada',
      code: 'NV'
    }, {
      name: 'New Hampshire',
      code: 'NH'
    }, {
      name: 'New Jersey',
      code: 'NJ'
    }, {
      name: 'New Mexico',
      code: 'NM'
    }, {
      name: 'New York',
      code: 'NY'
    }, {
      name: 'North Carolina',
      code: 'NC'
    }, {
      name: 'North Dakota',
      code: 'ND'
    }, {
      name: 'Ohio',
      code: 'OH'
    }, {
      name: 'Oklahoma',
      code: 'OK'
    }, {
      name: 'Oregon',
      code: 'OR'
    }, {
      name: 'Pennsylvania',
      code: 'PA'
    }, {
      name: 'Rhode Island',
      code: 'RI'
    }, {
      name: 'South Carolina',
      code: 'SC'
    }, {
      name: 'South Dakota',
      code: 'SD'
    }, {
      name: 'Tennessee',
      code: 'TN'
    }, {
      name: 'Texas',
      code: 'TX'
    }, {
      name: 'Utah',
      code: 'UT'
    }, {
      name: 'Vermont',
      code: 'VT'
    }, {
      name: 'Virginia',
      code: 'VA'
    }, {
      name: 'Washington',
      code: 'WA'
    }, {
      name: 'West Virginia',
      code: 'WV'
    }, {
      name: 'Wisconsin',
      code: 'WI'
    }, {
      name: 'Wyoming',
      code: 'WY'
    }],
    settings: {
      email_chars_limit: 950,
      customFields: []
    }
  }));
});

var getAvailableCountriesIdsMock = _msw.rest.get('/api/v1/available-countries', function (req, res, ctx) {
  return res(ctx.json({
    data: [1, 2, 3]
  }));
});

var commonDataMocks = [getCountriesMock, getCommonDataMock, getAvailableCountriesIdsMock];
exports.commonDataMocks = commonDataMocks;